import styled from "styled-components";
import Layout from "../../../components/custom/Layout";
import ActionIcon from "../../../components/custom/ActionIcon";
import { useEffect, useState } from "react";
import ProfileName from "./ProfileName";
import useSWR from "swr";
import { customFetcher } from "../../../utils";
import { AccessMap, IEmployee } from "../../../globals/interfaces";
import { Input } from "reactstrap";
import { Label } from "reactstrap";
import ModalAccessMap from "../../../components/hr/ModalAccessMap";
import useUser from "../../../customHooks/useUser";

export default function AccessMapProfiles() {

    const { user } = useUser();
    const {
        data,
        mutate
    } = useSWR('/accessMapProfiles', customFetcher<AccessMap>);
    const [email, setEmail] = useState('');
    const [modalName, setModalName] = useState(false);
    const [profileId, setProfileId] = useState('');
    const existingNames = new Set((data || []).map(item => (item.email)));
    const employee: Partial<IEmployee> = {
        s_email: email,
        s_first_name: email,
        s_last_name: ''
    } 

    const selectItem = (item) => {
        setEmail(item.email);
        setProfileId(item._id);
        setModalName(true);
    }

    const afterSubmit = () => {
        setEmail('');
        mutate();
    }

    const afterDelete = (_id: string) => {
        setEmail('');
        const filtered = data.filter(item => item._id !== _id);
        mutate(filtered, false);
    }

    return (
        <Layout>
            <h1>Access Map Profiles</h1>
            <FlexContainer>
                <Label>Name: </Label>
                <Input value={email} onChange={(e) => setEmail(e.target.value)} />
                <ActionIcon
                    type={'add'}
                    onClick={() => setModalName(true)}
                    disabled={existingNames.has(email) || !email || !email.length}
                />
            </FlexContainer>
            <FlexContainer className={'mt-2'}>
                {
                    (data || []).map((item, i) => (
                        <AccessMapButton 
                            key={i}
                            onClick={() => selectItem(item)}
                        >
                            {item.email}
                        </AccessMapButton>
                    ))
                }
            </FlexContainer>
            {/* <ProfileName
                modal={modalName}
                setModal={setModalName}
                setName={setName}
                existingNames={existingNames}
            /> */}
            <ModalAccessMap 
                user={user}
                modal={modalName}
                setModal={setModalName}
                // @ts-ignore
                selectedEmployee={employee}
                afterSubmit={afterSubmit}
                afterDelete={afterDelete}
                profile
                selectedProfileId={profileId}
            />
        </Layout>
    );
}

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 500px;
`;

const AccessMapButton = styled.div`
    border-radius: 25px;
    background-color: #51c878;
    width: 100px;
    padding: 10px;
    text-align: center;

    &:hover {
        background-color: #3f9a5d;
        color: white;
        cursor: pointer;
    }
`;